import { render, staticRenderFns } from "./CmgCountryFlag.vue?vue&type=template&id=2121d7c6&scoped=true&lang=pug"
import script from "./cmg-country-flag.ts?vue&type=script&lang=ts&external"
export * from "./cmg-country-flag.ts?vue&type=script&lang=ts&external"
import style0 from "./CmgCountryFlag.vue?vue&type=style&index=0&id=2121d7c6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2121d7c6",
  null
  
)

export default component.exports